import React, { useEffect, useState } from 'react';
import Media from 'react-media';
import { Link, useHistory } from 'react-router-dom';
import Loading from '../components/loading';
import * as api from '../service/api'

function UserAccess() {
    const history = useHistory()
    const [loading, setLoading] = useState(true)
    const [acessos, setAcessos] = useState([])

    useEffect(() => {
        setTimeout(() => {
            api.acessos()
                .then(res => {
                    if (!res.success) {
                        if (res.code == 0) {
                            history.replace('/logout')
                        }
                        return
                    }
                    setLoading(false)
                    setAcessos(res.acessos)
                })
        }, 500);
    }, [])

    return (
        <div className="container mx-auto pt-10 pb-16 px-4">
            <div className="flex justify-between items-center mb-3">
                <div>
                    <h1 className="text-3xl font-bold">Atividade recente</h1>
                    <p className="text-sm text-gray-400 mt-1">Histórico de acessos à sua conta</p>
                </div>
                <Link to="/app/account" className="text-sm text-blue-400 hover:text-blue-300 hover:underline">← Voltar</Link>
            </div>
            <hr className="border-orange-700 mb-6" />

            <Media query="(max-width: 599px)" render={() => (
                <div>
                    {loading ?
                        <Loading />
                        : acessos.length == 0
                            ? (<div className="mt-10 text-center"><span className="text-xl text-gray-500">Nenhum dado encontrado</span></div>)
                            : acessos.map((acesso, index) => (
                                <div key={index} className="flex flex-col bg-gray-800 border border-gray-700 rounded-lg my-3 p-4 gap-1">
                                    <span className="text-sm font-medium text-white">{acesso.horario}</span>
                                    <span className="text-sm text-gray-400">{acesso.aparelho}</span>
                                    <span className="text-xs text-gray-500">{acesso.ip}</span>
                                </div>
                            ))
                    }
                </div>
            )} />

            <Media query="(min-width: 600px)" render={() => (
                <div>
                    {loading ?
                        <Loading />
                        :
                        acessos.length == 0
                            ? (<div className="mt-10 text-center"><span className="text-xl text-gray-500">Nenhum dado encontrado</span></div>)
                            :
                            <table className="min-w-full table-auto">
                                <thead>
                                    <tr className="bg-gray-800 text-left text-sm text-gray-400">
                                        <th className="py-3 px-4">Horário</th>
                                        <th className="py-3 px-4">IP</th>
                                        <th className="py-3 px-4">Aparelho</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {acessos.map((acesso, index) => (
                                        <tr key={index} className="border-b border-gray-700 hover:bg-gray-800 transition-colors">
                                            <td className="py-3 px-4 text-sm font-medium text-white">{acesso.horario}</td>
                                            <td className="py-3 px-4 text-sm text-gray-400">{acesso.ip}</td>
                                            <td className="py-3 px-4 text-sm text-gray-400">{acesso.aparelho}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                    }
                </div>
            )} />
        </div>
    )
}

export default UserAccess;